import { render } from "./App.vue?vue&type=template&id=5df3be7e&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=5df3be7e&scoped=true&lang=css"
import "./App.vue?vue&type=style&index=1&id=5df3be7e&lang=css"

import exportComponent from "/var/www/vhosts/jahajibd.com/ia.jahajibd.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5df3be7e"]])

export default __exports__